export default __webpack_public_path__ + "static/media/pomodoro.31bcf02e.png";